import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 677B1C90-BB0B-4F73-8EEA-D6E8FA709A6D
 * name arrange-send-backward
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrange-send-backward.svg
 * tags
 * - Arrange 
 * - Geographic Information System 
 */
export const ArrangeSendBackwardIcon = createSvgIcon(<><path d="M2,2H16V16H2V2M22,8V22H8V18H18V8H22M4,4V14H14V4H4Z" /></>, 'ArrangeSendBackwardIcon');
export default ArrangeSendBackwardIcon